import Enums from "../../enums/enums";
const state = {
  bannerItems: [],
  bannerItemsLoadingStatus: Enums.LoadingStatusType.None,
  bannerDetail: [],
  bannerDetailLoadingStatus: Enums.LoadingStatusType.None,
};

const getters = {
  GetBannerItems: (state) => {
    return state.bannerItems;
  },
  GetBannerItemsLoadingStatus: (state) => {
    return state.bannerItemsLoadingStatus;
  },
  GetBannerDetail: (state) => {
    return state.bannerDetail;
  },
  GetBannerDetailLoadingStatus: (state) => {
    return state.bannerDetailLoadingStatus;
  },
};
export { getters, state };

